import React from 'react';

const PaymentFailpage = () => {
	return <div className='emptyPage'>Please try again</div>;
};

export default PaymentFailpage;
